export const HOME = '/';
export const ADD_INVENTORY_ITEM = '/add-inventory-item';
export const VIEW_INVENTORY_ITEM = '/view-inventory-item';
export const SALE = '/sale';
export const CUSTOMER = '/customer';
export const VIEW_CUSTOMER = '/viewcustomer';
export const ADD_EXPENSES = '/add-expenses';
export const VIEW_EXPENSES = '/view-expenses';
